export type itemType = undefined | string | number | boolean | object;
export default class Storage {
  private memoryStorage: { [key: string]: itemType } = {};
  public getItem(key: string): itemType {
    let serializedValue: string;
    try {
      serializedValue = localStorage.getItem(key) || '';
    } catch (e) {
      console.log('Failed to get from localStorage, falling back to memory', e); // tslint:disable-line: no-console
      return this.memoryStorage[key];
    }
    const type: string = serializedValue.replace(/(.+?):.+/, '$1');
    const proposedValue: string = serializedValue.replace(/.+?:(.+)/, '$1');

    switch (type) {
      case 'undefined':
        return undefined;
      case 'string':
        return proposedValue;
      case 'number':
        return Number(proposedValue);
      case 'boolean':
      case 'bool':
        return proposedValue === 'true';
      case 'object':
        try {
          return JSON.parse(proposedValue);
        } catch (e) {
          console.log('Failed to parse the object: ', proposedValue, e); // tslint:disable-line: no-console
          return undefined;
        }
    }

    return serializedValue;
  }

  public setItem(key: string, value: undefined | string | number | boolean | object) {
    let serializedValue: string;
    switch (typeof value) {
      case 'undefined':
        serializedValue = 'undefined:' + value;
      case 'string':
        serializedValue = 'string:' + value;
        break;
      case 'number':
        serializedValue = 'number:' + value;
        break;
      case 'boolean':
        serializedValue = 'boolean:' + value;
        break;
      case 'object':
        serializedValue = 'object:' + JSON.stringify(value);
        break;
    }

    try {
      localStorage.setItem(key, serializedValue || (value as string));
    } catch (e) {
      console.log('Failed to store in localStorage, falling back to memory', e); // tslint:disable-line: no-console
      this.memoryStorage[key] = value;
    }
  }

  public clearItem(key: string) {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.log('Failed to store in localStorage, falling back to memory', e); // tslint:disable-line: no-console
      this.memoryStorage[key] = undefined;
      delete this.memoryStorage[key];
    }
  }
}
